import { styled, css } from 'styled-components';

import { Section } from '../../Components/Section/index.tsx';

export const MobileSubmitSectionWrapper = styled(Section)`
  padding: 16px 12px;
  margin-top: 8px;
`;

export const mobileSubmitSectionItemsStyles = css`
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
